import { store } from "../store/index";
import {
  filterBatch,
  removeBatch,
  modifyBatch,
  getBatchByUuid,
  createBatch,
  getAll,
} from "../store/actions/BatchActions";

/**
 * Create Batch
 */
export const addBatch = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createBatch(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Get Batch
 */
export const getBatch = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getBatchByUuid(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Batch
 */
export const updateBatch = async (values, uuid) => {
  const objSend = { ...values };
  const result = await store.dispatch(modifyBatch(objSend, [uuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List Batch
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterBatch(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete Batch
 */
export const deleteBatch = async (uuid) => {
  const result = await store.dispatch(removeBatch([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Get all batchs
 */
export const getAllBatches = async (filters = {}) => {
  const result = await store.dispatch(getAll(filters));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
